import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SSEN-motif-dots",
  "use": "SSEN-motif-dots-usage",
  "viewBox": "0 0 50 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 50 11\" id=\"SSEN-motif-dots\"><path fill=\"#EBAC00\" d=\"M18.5 0a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z\" /><path fill=\"#A677A6\" d=\"M44.5 0a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z\" /><path fill=\"#629C49\" d=\"M31.5 0a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z\" /><path fill=\"#5B8C9D\" d=\"M5.5 0a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol